import { render, staticRenderFns } from "./sizhen-compose.vue?vue&type=template&id=2743ed46&scoped=true&"
import script from "./sizhen-compose.vue?vue&type=script&lang=ts&"
export * from "./sizhen-compose.vue?vue&type=script&lang=ts&"
import style0 from "./sizhen-compose.vue?vue&type=style&index=0&id=2743ed46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743ed46",
  null
  
)

export default component.exports